export default __webpack_public_path__ + "static/media/featureOne.3dfac18e.svg";